<div class="max-w-4xl mx-auto px-4 py-20">
  <div class="flex flex-col items-center gap-8">
    <div class="grid grid-cols-1 lg:grid-cols-3 w-full gap-32 pt-10">
      <div class="flex flex-col items-center">
        <div class="text-center text-slate-800 text-3xl font-medium mb-4">
          Starter
        </div>
        <div
          *ngIf="isYearly"
          class="text-slate-500 font-bold text-4xl flex items-center mb-2"
        >
          <div>12x</div>
          <div class="text-base font-medium mx-1">de R$</div>
          <div>99</div>
          <div class="text-base font-medium self-start">,00</div>
        </div>
        <div
          *ngIf="isYearly"
          class="text-slate-400 text-base font-medium leading-3 mb-8"
        >
          Total = R$ 1.080,00 / ano
        </div>
        <div
          *ngIf="!isYearly"
          class="text-green-600 font-bold text-4xl flex items-center mb-10"
        >
          Grátis
        </div>
        <a
          href="https://backoffice.mobo.com.br/#/onboarding?starter=true"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full px-8 py-3 rounded-full border-2 border-slate-300 justify-center items-center flex text-center text-slate-500 text-xl font-medium"
        >
          Assinar
        </a>
      </div>

      <div class="flex flex-col items-center relative">
        <div class="text-center text-primary-500 text-3xl font-medium mb-4">
          Pro
        </div>
        <div
          *ngIf="isYearly"
          class="text-primary-500 font-bold text-4xl flex items-center mb-2"
        >
          <div>12x</div>
          <div class="text-base font-medium mx-1">de R$</div>
          <div>290</div>
          <div class="text-base font-medium self-start">,00</div>
        </div>
        <div
          *ngIf="isYearly"
          class="text-primary-500 text-base font-medium leading-3 mb-8"
        >
          Total = R$ 3.480,00 / ano
        </div>
        <div
          *ngIf="!isYearly"
          class="text-primary-500 font-bold text-4xl flex items-center mb-10"
        >
          <div class="text-base font-medium mx-1">R$</div>
          <div>99</div>
          <div class="text-base font-medium self-start">,00</div>
        </div>
        <a
          href="https://backoffice.mobo.com.br/#/onboarding"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full px-8 py-3 rounded-full border-2 border-primary-500 bg-primary-500 justify-center items-center flex text-center text-white text-xl font-medium"
        >
          Assinar
        </a>
        <div
          class="absolute -top-10 px-3 py-2 bg-gradient-to-r from-blue-600 via-blue-600 to-sky-300 rounded text-center text-white text-xs font-medium leading-3 tracking-wide"
        >
          POPULAR
        </div>
      </div>

      <div class="flex flex-col items-center">
        <div class="text-center text-slate-800 text-3xl font-medium mb-4">
          Premium
        </div>
        <div
          *ngIf="isYearly"
          class="text-slate-500 font-bold text-4xl flex items-center mb-2"
        >
          <div>12x</div>
          <div class="text-base font-medium mx-1">de R$</div>
          <div>890</div>
          <div class="text-base font-medium self-start">,00</div>
        </div>
        <div
          *ngIf="isYearly"
          class="text-slate-400 text-base font-medium leading-3 mb-8"
        >
          Total = R$ 10.680,00 / ano
        </div>
        <div
          *ngIf="!isYearly"
          class="text-slate-500 font-bold text-4xl flex items-center mb-10"
        >
          <div class="text-base font-medium mx-1">R$</div>
          <div>399</div>
          <div class="text-base font-medium self-start">,00</div>
        </div>
        <a
          href="https://backoffice.mobo.com.br/#/onboarding"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full px-8 py-3 rounded-full border-2 border-secondary-500 justify-center items-center flex text-center text-secondary-500 text-xl font-medium"
        >
          Assinar
        </a>
      </div>
    </div>
  </div>
</div>
